import SiteLayout from './SiteLayout';
import SEO from '../../components/layout/SEO';
import Hero from '../../components/marketing/Hero';
import Reveal from '../../components/marketing/Reveal';
import ShopStory from '../../components/marketing/ShopStory';
import WorksFeature from '../../components/marketing/WorksFeature';
import CrewGrid from '../../components/marketing/CrewGrid';
import Gallery from '../../components/marketing/Gallery';
import ServicesTeaser from '../../components/marketing/ServicesTeaser';
import ReviewsBlock from '../../components/marketing/ReviewsBlock';
import VisitSection from '../../components/marketing/VisitSection';
import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';

/** Homepage — content pass §1.1 through §1.8, in order. */
export default function HomePage() {
  const c = useCopy().home;
  const { t } = useShopConfig();
  return (
    <SiteLayout>
      {/* The meta description mirrors what the hero actually says, so it
          follows the hero's client copy rather than the retired subhead. */}
      <SEO
        title={t(c.hero.headline)}
        description={t(`${c.hero.intro.line1} ${c.hero.intro.line2}`)}
      />
      <Hero />
      <Reveal>
        <ShopStory />
      </Reveal>
      {/* The Works ($80 premium) sets the pricing anchor; menu follows
          immediately with services from $15 (senior) to $80 (The Works) —
          classic anchor-then-menu pricing psychology. Gallery keeps its
          slot after TheSpace; it was absent from the brief's order and
          deleting a working section was not on the table. */}
      <Reveal>
        <WorksFeature />
      </Reveal>
      <Reveal>
        <ServicesTeaser />
      </Reveal>
      <Reveal>
        <CrewGrid variant="short" />
      </Reveal>
      <Reveal>
        <Gallery />
      </Reveal>
      <Reveal>
        <ReviewsBlock />
      </Reveal>
      <Reveal>
        <VisitSection />
      </Reveal>
    </SiteLayout>
  );
}
